import type { TagCategory, TagType } from '../types';

export const TAG_TYPES: ReadonlyArray<TagType> = [
  { key: 'support', label: 'Support', icon: 'support_agent' },
  { key: 'org', label: 'Organisation', icon: 'corporate_fare' },
  { key: 'account', label: 'Account', icon: 'apartment' },
  { key: 'user', label: 'User', icon: 'person' },
  { key: 'survey', label: 'Survey', icon: 'assignment' },
  { key: 'report', label: 'Report', icon: 'summarize' },
];

export const TAG_CATEGORIES: ReadonlyArray<TagCategory> = [
  { id: 'cat-region', typeKey: 'account', name: 'Region', icon: 'public' },
  { id: 'cat-brand', typeKey: 'account', name: 'Brand', icon: 'sell' },
  { id: 'cat-property-type', typeKey: 'account', name: 'Property Type', icon: 'apartment' },
  { id: 'cat-market', typeKey: 'account', name: 'Market Segment', icon: 'groups' },

  { id: 'cat-survey-type', typeKey: 'survey', name: 'Survey Type', icon: 'assignment' },
  { id: 'cat-survey-stage', typeKey: 'survey', name: 'Guest Journey Stage', icon: 'route' },
  { id: 'cat-sentiment', typeKey: 'survey', name: 'Sentiment', icon: 'sentiment_satisfied' },
  { id: 'cat-publication', typeKey: 'survey', name: 'Publication', icon: 'visibility' },
  { id: 'cat-review-source', typeKey: 'survey', name: 'Review Source', icon: 'reviews' },

  { id: 'cat-role', typeKey: 'user', name: 'Role', icon: 'badge' },
  { id: 'cat-team', typeKey: 'user', name: 'Team', icon: 'diversity_3' },

  { id: 'cat-org-tier', typeKey: 'org', name: 'Tier', icon: 'workspace_premium' },

  { id: 'cat-report-purpose', typeKey: 'report', name: 'Purpose', icon: 'flag' },

  { id: 'cat-support-topic', typeKey: 'support', name: 'Support Topic', icon: 'support_agent' },
];
